import { createSlice } from "@reduxjs/toolkit";

const initialState = {
    totalcartitem : 0
    
}

const cart = createSlice({
    name:'cart',
    initialState,
    reducers:{
        cartItem:(state,action)=>{
            state.totalcartitem = action.payload;
        }
    }
})
export const {cartItem} = cart.actions;
export default cart.reducer;